import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import Home from '../screens/Home'
import FindThreeMobilePrivacyPolicy from '../screens/Legal/FindThreeMobilePrivacyPolicy'
import StickersPrivacyPolicy from '../screens/Legal/StickersPrivacyPolicy'
import userHomePath from './components/userHomePath'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

const Routes = () => (
  <Switch>
    <Route exact path='/' component={Home}/>
    <Route path='/legal/find-three-mobile-privacy-policy' component={FindThreeMobilePrivacyPolicy}/>
    <Route path='/legal/stickers-privacy-policy' component={StickersPrivacyPolicy}/>
    <Redirect to={userHomePath()}/>
  </Switch>
)

export default withRouter(connect()(Routes))



// WEBPACK FOOTER //
// ./src/routes/Routes.js